import React, { Component } from 'react';
import { Grid, Form } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import { TrackedInput } from 'Components';
import { InputMode } from 'Common/FormEnum';

class ChangeBalanceLine extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    currentValue: PropTypes.number.isRequired,
    updatedValue: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
  };

  static defaultProps = {
    currentValue: 0,
    updatedValue: 0,
  };

  render() {
    const { title, currentValue, adjustment, updatedValue } = this.props;

    return (
      <Form>
        <Grid>
          <Grid.Row columns={6}>
            <Grid.Column className="column--label" width={4}>
              {title}
            </Grid.Column>
            <Grid.Column className="column--currency" width={3}>
              {currentValue.toFixed(2)}
            </Grid.Column>
            <Grid.Column className="column--center" width={1}>
              <span className="change-balance--plus-icon">+</span>
            </Grid.Column>
            <Grid.Column className="column--center" width={4}>
              <TrackedInput
                track={false}
                initialValue={adjustment}
                onChange={this.props.onChange}
                className="input--currency"
                mode={InputMode.Decimal}
                numericSize={[6, 2]}
                allowNegative
              />
            </Grid.Column>
            <Grid.Column className="column--center" width={1}>
              <span className="change-balance--equals-icon">=</span>
            </Grid.Column>
            <Grid.Column className="column--currency" width={3}>
              {updatedValue.toFixed(2)}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}

export { ChangeBalanceLine };



// WEBPACK FOOTER //
// ./src/pages/accountsetup/components/changebalance/ChangeBalanceLine.js